import * as React from 'react';
import * as styles from '../clients.module.scss';
import { PaginatedClientContext } from '../../../../shared/paginated-client-context';
import Scrollbars from 'react-custom-scrollbars';
import ClientEntry from './client-entry';
import Table from '../../../table/table';
import TableHead from '../../../table/table-head';
import TableBody from '../../../table/table-body';
import HeaderCell from '../../../table/table-header-cell';
import { ClientSortingOptions } from '../../../../models/enums/adminSortingOptions';
import usePaginatedClients from '../../../../hooks/usePaginatedClients';

interface ClientTableProps {
  loading: boolean;
  isClientAdmin: boolean;
}

const ClientTable = ({ loading, isClientAdmin }: ClientTableProps) => {
  const { results, pageSize, orderColumn, orderDirection, searchTerm } = React.useContext(PaginatedClientContext);
  const { fetchClientsPage } = usePaginatedClients();
  const reorderHandler = (orderColumn: string, orderDirection: 'asc' | 'desc') => {
    fetchClientsPage({ currentPage: 1, pageSize, orderColumn, orderDirection, searchTerm });
  };
  return (
    <div className={styles.tableWrapper}>
      <div style={{ height: '90%' }}>
        <Scrollbars className={styles.scrollTable} autoHide={true} universal={true}>
          <Table loading={loading} results={results}>
            <TableHead>
              <HeaderCell
                title="Name"
                scope="col"
                orderField={ClientSortingOptions.Name}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell
                title="Display Name"
                scope="col"
                orderField={ClientSortingOptions.DisplayName}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell
                title="Administrator"
                scope="col"
                orderField={ClientSortingOptions.Administrator}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell
                title="Status"
                scope="col"
                orderField={ClientSortingOptions.Status}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell title="" />
            </TableHead>
            <TableBody>
              {!results || results.length === 0 ? (
                <tr>
                  <td>There are no clients.</td>
                </tr>
              ) : (
                results.map((client) => {
                  return <ClientEntry client={client} key={client.clientId} isClientAdmin={isClientAdmin} />;
                })
              )}
            </TableBody>
          </Table>
        </Scrollbars>
      </div>
    </div>
  );
};

export default ClientTable;
